import {baseUrl, pbrAxios} from '../../common/js/pbrAxios'
import {contentType, exportFile} from '../common'


/**
 * 前端-风险导出excel列表接口
 * @param params
 *  @param {String} params.selections: 选择导出的列的ID并以逗号分隔，不添加参数时为全导出
 *  @param {String} params.from: 语言
 * @param fileName: 文件名
 */
const exportListExcel = (params, fileName) => exportFile('/front/risk/exportListXls', params, fileName, contentType.excel, '.xlsx')

/**
 * 前端-风险导出word详情接口
 * @param params
 *  @param {String} params.id: 风险id
 *  @param {String} params.userId: 登录用户id
 *  @param {String} [params.from]: 语言
 * @param fileName： 文件名
 */
const exportDetailWord = (params, fileName) => exportFile('/front/risk/exportDetailWord', params, fileName, contentType.word, '.docx')
const exportRiskListExcelUrl = `/front/article/exportListXls`
const exportRiskDetailWordUrl = `/front/risk/exportDetailWord`


export default {
  exportListExcel,
  exportDetailWord,
  exportRiskListExcelUrl,
  exportRiskDetailWordUrl
}
